module.exports = __webpack_public_path__ + "static/media/coin.a818b1e4.png";